import { JsonObject } from '../../helpers';
import { PrivateModelModel } from './private-model.model';

export type VertexPrivateModelConfig = {
  region: string;
};

const DEFAULT_REGION = 'us-east1';

export class VertexPrivateModelModel extends PrivateModelModel {
  config: VertexPrivateModelConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof PrivateModelModel, unknown>;

    this.provider = 'vertex_ai';

    this.config = (data.config as VertexPrivateModelConfig) || {
      region: DEFAULT_REGION,
    };
  }
}
